(function () {

  function isBoostPages() {
    return document.body.classList.contains("template-collection") ||
           document.body.classList.contains("template-search");
  }

  function openNativeCart() {
    if (!window.jQuery) return;
    window.jQuery('.header-cart').first().trigger('click');
  }

  // 1) Estä Boostin cart-link kaappaus
  function isHeaderCartLink(el) {
  if (!el || !el.closest) return false;

  var link = el.closest('header a[href="/cart"], a[href="/cart"].site-header__cart');
  if (!link) return false;

  // Älä kaappaa klikkejä jos ne tulevat korin sisältä
  if (el.closest('#cartDrawer') || el.closest('#cartPopup') || el.closest('.mfp-content')) {
    return false;
  }

  return true;
}

  document.addEventListener('click', function (e) {
    if (!isBoostPages()) return;
    if (!isHeaderCartLink(e.target)) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    openNativeCart();
  }, true);

  // 2) Hookataan vain fetch, koska Boost käyttää sitä
  if (window.fetch) {
  const origFetch = window.fetch;

  window.fetch = function (input, init) {

    const url = typeof input === "string"
      ? input
      : (input && input.url ? input.url : "");

    const promise = origFetch.apply(this, arguments);

    if (isBoostPages() && url.indexOf('/cart/add') !== -1) {

      return promise.then(function (res) {

        if (res && res.ok) {

          // Päivitä CartJS malli jotta minikori renderöityy oikein
          if (window.CartJS) {

            CartJS.getCart();

            jQuery(document).one('cart.requestComplete', function () {
              openNativeCart();
            });

          } else {
            openNativeCart();
          }

        }

        return res;
      });

    }

    return promise;
  };
}

})();
